



































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { API } from "@/shared/api";
import { ssmHttpService } from "@/shared/services/http-service";
import { MessageService } from "@/shared/services/message-service";
import { citasHubService } from "@/shared/services/CitasHubService";
import { webPushClientService } from "@/shared/services/WebPushClientService";
import CitaDetalleDialog from "./components/CitaDetalleDialog.vue";

@Component({
  name: "CitasDashboard",
  components: { CitaDetalleDialog },
})
export default class CitasDashboard extends Vue {
  public cargando = false;
  public busqueda = "";
  public filtroCentro: number | null = null;
  public filtroEstado: string | null = null;
  public focoTrabajo:
    | "pendientes"
    | "insertar"
    | "revisar"
    | "conflictos"
    | "fallidas"
    | "cancelacion_gesden"
    | "reagendado_gesden"
    | null = null;
  public lastRefresh = "";
  public dialogDetalle = false;
  public detalle: any = null;
  public accionLoading: string | null = null;
  public pushActivo = false;
  public pushLoading = false;
  public refreshCountdown = 90;

  public todasLasFilas: any[] = [];
  public catalogos: any = { centros: [], servicios: [], estados: [] };

  private unsubscribe: (() => void) | null = null;
  private refreshTimer: ReturnType<typeof setInterval> | null = null;
  private countdownTimer: ReturnType<typeof setInterval> | null = null;

  get primeraCarga(): boolean {
    return this.cargando && this.todasLasFilas.length === 0;
  }

  get rowsBase(): any[] {
    let rows = this.todasLasFilas;
    if (this.filtroCentro) {
      rows = rows.filter((r) => r.id_centro === this.filtroCentro);
    }
    if (this.filtroEstado) {
      rows = rows.filter((r) => r.estado_codigo === this.filtroEstado);
    }
    return rows;
  }

  get filasFiltradas(): any[] {
    let rows = this.rowsBase;
    if (this.focoTrabajo === "cancelacion_gesden") {
      rows = rows.filter(
        (r) => r.estado_codigo === "cancelacion_pendiente_gesden"
      );
    } else if (this.focoTrabajo === "reagendado_gesden") {
      rows = rows.filter(
        (r) => r.estado_codigo === "reagendado_pendiente_gesden"
      );
    } else if (this.focoTrabajo === "pendientes") {
      rows = rows.filter((r) => r.estado_codigo === "pendiente");
    } else if (this.focoTrabajo === "insertar") {
      rows = rows.filter(
        (r) =>
          !r.fecha_insercion_gesden &&
          ["pendiente", "confirmada", "enviada_gesden"].includes(
            r.estado_codigo
          )
      );
    } else if (this.focoTrabajo === "revisar") {
      rows = rows.filter((r) => r.necesita_accion);
    } else if (this.focoTrabajo === "conflictos") {
      rows = rows.filter((r) => r.conflicto_detectado);
    } else if (this.focoTrabajo === "fallidas") {
      rows = rows.filter((r) => r.estado_codigo === "fallida_gesden");
    }
    return rows;
  }

  get centrosSelect() {
    return (this.catalogos.centros || []).map((c: any) => ({
      text: c.nombre,
      value: c.id,
    }));
  }

  get estadosSelect() {
    return (this.catalogos.estados || []).map((e: any) => ({
      text: e.nombre,
      value: e.codigo,
    }));
  }

  get kpis() {
    const rows = this.rowsBase;
    const total = rows.length;
    const pendientes = rows.filter(
      (r) => r.estado_codigo === "pendiente"
    ).length;
    const confirmadas = rows.filter(
      (r) => r.estado_codigo === "confirmada"
    ).length;
    const insertadas = rows.filter((r) => r.fecha_insercion_gesden).length;
    const conflictos = rows.filter((r) => r.conflicto_detectado).length;
    const accionRequerida = rows.filter((r) => r.necesita_accion).length;
    return [
      {
        label: "Total",
        valor: total,
        color: "primary",
        icono: "mdi-calendar-multiple",
      },
      {
        label: "Pendientes",
        valor: pendientes,
        color: "blue-grey",
        icono: "mdi-clock-outline",
      },
      {
        label: "Confirmadas",
        valor: confirmadas,
        color: "teal darken-1",
        icono: "mdi-check-circle-outline",
      },
      {
        label: "En Gesden",
        valor: insertadas,
        color: "green darken-1",
        icono: "mdi-database-check",
      },
      {
        label: "Conflictos",
        valor: conflictos,
        color: "red darken-1",
        icono: "mdi-alert",
      },
      {
        label: "Revisar Gesden",
        valor: accionRequerida,
        color: "orange darken-1",
        icono: "mdi-pencil-alert",
      },
    ];
  }

  get graficoEstados() {
    const rows = this.rowsBase;
    const mapa: Record<string, number> = {};
    rows.forEach((r) => {
      const k = r.estado_nombre || r.estado_codigo || "desconocido";
      mapa[k] = (mapa[k] || 0) + 1;
    });
    const colores: Record<string, string> = {
      pendiente: "#78909C",
      en_revision: "#42A5F5",
      confirmada: "#26A69A",
      enviada_gesden: "#AB47BC",
      insertada_gesden: "#66BB6A",
      fallida_gesden: "#FFA726",
      conflicto: "#EF5350",
      cancelada: "#BDBDBD",
      rechazada: "#E53935",
      expirada: "#9E9E9E",
    };
    const total = rows.length || 1;
    return Object.entries(mapa)
      .sort((a, b) => b[1] - a[1])
      .map(([estado, cnt]) => {
        const key = Object.keys(colores).find((k) =>
          estado.toLowerCase().includes(k)
        );
        return {
          estado,
          total: cnt,
          pct: Math.round((cnt / total) * 100),
          color: key ? colores[key] : "#90A4AE",
        };
      });
  }

  get graficoServicios() {
    const rows = this.rowsBase;
    const mapa: Record<string, number> = {};
    rows.forEach((r) => {
      const k = r.servicio_nombre || r.servicio_codigo || "Desconocido";
      mapa[k] = (mapa[k] || 0) + 1;
    });
    const total = rows.length || 1;
    return Object.entries(mapa)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 10)
      .map(([servicio, cnt]) => ({
        servicio,
        total: cnt,
        pct: Math.round((cnt / total) * 100),
      }));
  }

  get pendienteCancelacionGesden() {
    return this.rowsBase.filter(
      (r) => r.estado_codigo === "cancelacion_pendiente_gesden"
    ).length;
  }

  get pendienteReagendadoGesden() {
    return this.rowsBase.filter(
      (r) => r.estado_codigo === "reagendado_pendiente_gesden"
    ).length;
  }

  get pendienteInsertar() {
    return this.rowsBase.filter(
      (r) =>
        !r.fecha_insercion_gesden &&
        ["pendiente", "confirmada", "enviada_gesden"].includes(r.estado_codigo)
    ).length;
  }

  get pendienteRevisar() {
    return this.rowsBase.filter((r) => r.necesita_accion).length;
  }

  get pendientesAccion() {
    return this.rowsBase.filter((r) => r.estado_codigo === "pendiente").length;
  }

  get conflictos() {
    return this.rowsBase.filter((r) => r.conflicto_detectado).length;
  }

  get fallidasGesden() {
    return this.rowsBase.filter((r) => r.estado_codigo === "fallida_gesden")
      .length;
  }

  get estadoTrabajoLabel(): string {
    if (this.fallidasGesden > 0 || this.conflictos > 0) {
      return "Crítico";
    }
    if (
      this.pendienteCancelacionGesden > 0 ||
      this.pendienteReagendadoGesden > 0
    ) {
      return "Urgente";
    }
    if (
      this.pendienteInsertar > 0 ||
      this.pendienteRevisar > 0 ||
      this.pendientesAccion > 0
    ) {
      return "Atención";
    }
    return "Al día";
  }

  get estadoTrabajoColor(): string {
    if (this.fallidasGesden > 0 || this.conflictos > 0) {
      return "red darken-1";
    }
    if (
      this.pendienteCancelacionGesden > 0 ||
      this.pendienteReagendadoGesden > 0
    ) {
      return "deep-orange darken-1";
    }
    if (
      this.pendienteInsertar > 0 ||
      this.pendienteRevisar > 0 ||
      this.pendientesAccion > 0
    ) {
      return "orange darken-1";
    }
    return "green darken-1";
  }

  get estadoTrabajoIcon(): string {
    if (this.fallidasGesden > 0 || this.conflictos > 0) {
      return "mdi-alert-circle";
    }
    if (
      this.pendienteCancelacionGesden > 0 ||
      this.pendienteReagendadoGesden > 0
    ) {
      return "mdi-alert";
    }
    if (this.pendienteInsertar > 0 || this.pendientesAccion > 0) {
      return "mdi-information";
    }
    return "mdi-check-circle";
  }

  get completionPercent(): number {
    const counts = [
      this.pendienteCancelacionGesden,
      this.pendienteReagendadoGesden,
      this.conflictos,
      this.fallidasGesden,
      this.pendientesAccion,
      this.pendienteInsertar,
    ];
    const done = counts.filter((c) => c === 0).length;
    return Math.round((done / counts.length) * 100);
  }

  get pipelineEstados() {
    const rows = this.rowsBase;
    return [
      {
        codigo: "pendiente",
        label: "Pendientes",
        icono: "mdi-clock-outline",
        color: "blue-grey darken-1",
        rawColor: "#546E7A",
        colorText: "blue-grey--text darken-1",
        count: rows.filter((r) => r.estado_codigo === "pendiente").length,
      },
      {
        codigo: "confirmada",
        label: "Confirmadas",
        icono: "mdi-check-circle-outline",
        color: "teal darken-1",
        rawColor: "#00796B",
        colorText: "teal--text darken-1",
        count: rows.filter((r) => r.estado_codigo === "confirmada").length,
      },
      {
        codigo: "enviada_gesden",
        label: "Enviadas",
        icono: "mdi-send-circle-outline",
        color: "purple darken-1",
        rawColor: "#6A1B9A",
        colorText: "purple--text darken-1",
        count: rows.filter((r) => r.estado_codigo === "enviada_gesden").length,
      },
      {
        codigo: "insertada_gesden",
        label: "En GESDEN",
        icono: "mdi-database-check",
        color: "green darken-1",
        rawColor: "#388E3C",
        colorText: "green--text darken-1",
        count: rows.filter((r) => r.fecha_insercion_gesden).length,
      },
      {
        codigo: "cancelada",
        label: "Canceladas",
        icono: "mdi-calendar-remove",
        color: "grey darken-1",
        rawColor: "#757575",
        colorText: "grey--text darken-1",
        badgeColor: "#9E9E9E",
        count: rows.filter((r) =>
          ["cancelada", "rechazada", "expirada"].includes(r.estado_codigo)
        ).length,
      },
    ];
  }

  get tareasGuiadas() {
    return [
      {
        id: "cancelacion_gesden",
        prioridad: 1,
        urgente: true,
        titulo: "Cancelar en GESDEN",
        descripcion: "Citas canceladas que aún existen en GESDEN — actúa hoy",
        color: "deep-orange darken-2",
        rawColor: "#BF360C",
        count: this.pendienteCancelacionGesden,
      },
      {
        id: "reagendado_gesden",
        prioridad: 2,
        urgente: true,
        titulo: "Mover en GESDEN",
        descripcion: "Citas reagendadas que debes actualizar en GESDEN",
        color: "amber darken-3",
        rawColor: "#FF8F00",
        count: this.pendienteReagendadoGesden,
      },
      {
        id: "conflictos",
        prioridad: 3,
        urgente: true,
        titulo: "Resolver conflictos",
        descripcion: "Conflictos activos que pueden bloquear el flujo",
        color: "red darken-1",
        rawColor: "#C62828",
        count: this.conflictos,
      },
      {
        id: "fallidas",
        prioridad: 4,
        urgente: false,
        titulo: "Reprocesar fallidas",
        descripcion: "Citas que fallaron al insertarse en GESDEN",
        color: "orange darken-2",
        rawColor: "#E65100",
        count: this.fallidasGesden,
      },
      {
        id: "pendientes",
        prioridad: 5,
        urgente: false,
        titulo: "Gestionar pendientes",
        descripcion: "Citas en estado pendiente esperando gestión",
        color: "blue-grey darken-1",
        rawColor: "#546E7A",
        count: this.pendientesAccion,
      },
      {
        id: "insertar",
        prioridad: 6,
        urgente: false,
        titulo: "Insertar en GESDEN",
        descripcion: "Citas confirmadas listas para insertar",
        color: "indigo darken-1",
        rawColor: "#283593",
        count: this.pendienteInsertar,
      },
    ];
  }

  get resumenTrabajo(): string {
    if (this.fallidasGesden > 0) {
      return "Revisa primero las citas fallidas en Gesden y reprocesalas.";
    }
    if (this.conflictos > 0) {
      return "Hay conflictos activos. Prioriza resolverlos para evitar bloqueos.";
    }
    if (
      this.pendienteCancelacionGesden > 0 ||
      this.pendienteReagendadoGesden > 0
    ) {
      return "Acción urgente en GESDEN: hay citas canceladas o movidas que debes tramitar.";
    }
    if (
      this.pendienteRevisar > 0 ||
      this.pendienteInsertar > 0 ||
      this.pendientesAccion > 0
    ) {
      return "Tienes tareas pendientes en Gesden. Usa la lista para ir al listado filtrado.";
    }
    return "No hay tareas pendientes para los filtros actuales. ¡Buen trabajo!";
  }

  public headers = [
    { text: "Paciente", value: "paciente_nombre", sortable: true },
    { text: "Centro", value: "centro_nombre", sortable: true },
    { text: "Tipo de cita", value: "servicio_nombre", sortable: true },
    { text: "Doctor", value: "nombre_profesional", sortable: true },
    {
      text: "Fecha",
      value: "fecha_hora_inicio_solicitada",
      sortable: true,
    },
    { text: "Estado", value: "estado_codigo", sortable: true },
    {
      text: "Conflicto",
      value: "conflicto_detectado",
      sortable: true,
      align: "center",
    },
    { text: "Gesden", value: "gesden", sortable: false, align: "center" },
    {
      text: "Revisar",
      value: "necesita_accion",
      sortable: true,
      align: "center",
    },
    { text: "", value: "acciones", sortable: false, align: "center" },
  ];

  public async mounted() {
    await Promise.all([this.cargarCatalogos(), this.cargar()]);
    this.unsubscribe = citasHubService.onEvento(() => { this.cargar(); });
    this._actualizarEstadoPush();
    this._iniciarAutoRefresh();
  }

  public beforeDestroy() {
    if (this.unsubscribe) { this.unsubscribe(); }
    this._detenerAutoRefresh();
  }

  private _iniciarAutoRefresh() {
    this.refreshCountdown = 90;
    this.refreshTimer = setInterval(() => { this.cargar(); }, 90_000);
    this.countdownTimer = setInterval(() => {
      this.refreshCountdown = this.refreshCountdown > 0 ? this.refreshCountdown - 1 : 90;
    }, 1_000);
  }

  private _detenerAutoRefresh() {
    if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; }
    if (this.countdownTimer) { clearInterval(this.countdownTimer); this.countdownTimer = null; }
  }

  public async cargarCatalogos() {
    try {
      const res = await ssmHttpService.get(
        `${API.solicitudesWorkflow}/admin/catalogos`,
        null,
        false
      );
      if (res && res.data) {
        this.catalogos = res.data;
      } else if (res && res.centros) {
        this.catalogos = res;
      }
    } catch (e) {
      // silencioso
    }
  }

  public cargarManual() {
    this.refreshCountdown = 90;
    this._detenerAutoRefresh();
    this._iniciarAutoRefresh();
    this.cargar();
  }

  public async cargar() {
    this.refreshCountdown = 90;
    this.cargando = true;
    try {
      const params: any = {};
      if (this.filtroCentro) {
        params.id_centro = this.filtroCentro;
      }
      const query = Object.keys(params)
        .map((k) => `${k}=${params[k]}`)
        .join("&");
      const url = `${API.solicitudesWorkflow}/admin/tablero${
        query ? "?" + query : ""
      }`;
      const res = await ssmHttpService.get(url, null, false);
      const rows =
        (res && res.data ? res.data.rows : res && res.rows ? res.rows : []) ||
        [];

      this.todasLasFilas = rows.map((r: any) => ({
        ...r,
        necesita_accion: [
          "cancelacion_pendiente_gesden",
          "reagendado_pendiente_gesden",
        ].includes(r.estado_codigo),
      }));

      const now = new Date();
      this.lastRefresh = `Actualizado: ${this._pad(now.getHours())}:${this._pad(
        now.getMinutes()
      )}:${this._pad(now.getSeconds())}`;
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudieron cargar las citas",
        MessageService.TypeError
      );
    } finally {
      this.cargando = false;
    }
  }

  public aplicarFiltros() {
    this.cargar();
  }

  public aplicarFoco(
    foco:
      | "pendientes"
      | "insertar"
      | "revisar"
      | "conflictos"
      | "fallidas"
      | "cancelacion_gesden"
      | "reagendado_gesden"
      | null
  ) {
    this.focoTrabajo = this.focoTrabajo === foco ? null : foco;
  }

  public async ejecutarAccionConMensaje(
    id: number,
    accion: string,
    mensajeOk: string
  ) {
    this.accionLoading = accion;
    try {
      const res = await ssmHttpService.post(
        `${API.solicitudesWorkflow}/admin/${id}/accion`,
        { accion },
        false,
        false,
        false,
        citasHubService.getConnectionHeader()
      );
      if (res && (res.success || res.data)) {
        MessageService.toast(mensajeOk);
        this.dialogDetalle = false;
        await this.cargar();
      }
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo ejecutar la acción",
        MessageService.TypeError
      );
    } finally {
      this.accionLoading = null;
    }
  }

  public rowClass(item: any): string {
    if (item.estado_codigo === "cancelacion_pendiente_gesden")
      return "fila-urgente-cancelacion";
    if (item.estado_codigo === "reagendado_pendiente_gesden")
      return "fila-urgente-reagendado";
    return "";
  }

  public abrirDetalle(item: any) {
    this.detalle = item;
    this.dialogDetalle = true;
  }

  public async ejecutarAccion(id: number, accion: string) {
    this.accionLoading = accion;
    try {
      const url = `${API.solicitudesWorkflow}/admin/${id}/accion`;
      const res = await ssmHttpService.post(
        url,
        { accion },
        false,
        false,
        false,
        citasHubService.getConnectionHeader()
      );
      if (res && (res.success || res.data)) {
        MessageService.toast(`Acción '${accion}' ejecutada`);
        this.dialogDetalle = false;
        await this.cargar();
      }
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo ejecutar la acción",
        MessageService.TypeError
      );
    } finally {
      this.accionLoading = null;
    }
  }

  public async togglePushNotificaciones() {
    this.pushLoading = true;
    try {
      if (this.pushActivo) {
        await webPushClientService.desuscribir();
        this.pushActivo = false;
        MessageService.toast("Notificaciones desactivadas");
      } else {
        await webPushClientService.suscribirSiPermitido();
        this._actualizarEstadoPush();
        if (this.pushActivo) {
          MessageService.toast("Notificaciones activadas");
        } else {
          MessageService.toast(
            "Permiso denegado o no soportado",
            MessageService.TypeWarning
          );
        }
      }
    } catch (e) {
      MessageService.alert(
        "Error",
        "No se pudo cambiar el estado de las notificaciones",
        MessageService.TypeError
      );
    } finally {
      this.pushLoading = false;
    }
  }

  private _actualizarEstadoPush() {
    if (!webPushClientService.isSupported()) {
      this.pushActivo = false;
      return;
    }
    this.pushActivo = webPushClientService.getPermissionState() === "granted";
  }

  public formatFecha(v: string): string {
    if (!v) {
      return "-";
    }
    const d = new Date(v);
    if (isNaN(d.getTime())) {
      return v;
    }
    return `${this._pad(d.getDate())}/${this._pad(
      d.getMonth() + 1
    )}/${d.getFullYear()} ${this._pad(d.getHours())}:${this._pad(
      d.getMinutes()
    )}`;
  }

  public colorEstado(codigo: string): string {
    const m: Record<string, string> = {
      pendiente: "blue-grey",
      en_revision: "blue",
      confirmada: "teal",
      enviada_gesden: "purple",
      insertada_gesden: "green",
      fallida_gesden: "orange",
      conflicto: "red",
      cancelada: "grey",
      rechazada: "red darken-3",
      expirada: "grey darken-1",
      cancelacion_pendiente_gesden: "deep-orange darken-1",
      reagendado_pendiente_gesden: "amber darken-2",
    };
    return m[codigo] || "grey";
  }

  public etiquetaAccion(accion: string): string {
    const etiquetas: Record<string, string> = {
      marcar_en_revision: "Poner en revisión",
      confirmar: "Confirmar",
      marcar_enviada_gesden: "Enviada a GESDEN",
      marcar_insertada_gesden: "Insertada en GESDEN",
      cancelacion_pendiente_gesden: "Cancelar en GESDEN (pendiente)",
      reagendado_pendiente_gesden: "Reagendar en GESDEN (pendiente)",
      marcar_conflicto: "Marcar conflicto",
      marcar_fallida_gesden: "Fallida en GESDEN",
      rechazar: "Rechazar",
      cancelar: "Cancelar",
      expirar: "Expirar",
      confirmar_cancelacion_gesden: "✓ Cancelé en GESDEN",
      confirmar_reagendado_gesden: "✓ Moví en GESDEN",
    };
    return etiquetas[accion] || accion.replace(/_/g, " ");
  }

  public colorAccion(accion: string): string {
    if (accion.includes("cancelacion_pendiente_gesden")) {
      return "deep-orange";
    }
    if (accion.includes("reagendado_pendiente_gesden")) {
      return "amber darken-2";
    }
    if (
      accion.includes("cancelar") ||
      accion.includes("rechazar") ||
      accion.includes("expirar")
    ) {
      return "red";
    }
    if (accion.includes("conflicto") || accion.includes("fallida")) {
      return "orange";
    }
    if (accion.includes("confirmar") || accion.includes("insertada")) {
      return "green";
    }
    return "primary";
  }

  private _pad(n: number): string {
    return n < 10 ? "0" + n : "" + n;
  }
}
